export default "__VITE_ASSET__CvQmThUJ__"